import { gql } from "@apollo/client";

export const GET_NOTIFICATION_CHANNEL_STATUS = gql`
  query GetNotificationChannelStatus {
    getNotificationChannelStatus
  }
`;

export const GET_USER_NOTIFICATION_PREFERENCES = gql`
  query GetUserNotificationPreferences($userId: String!) {
    getUserNotificationPreferences(userId: $userId)
  }
`;

export const GET_NOTIFICATION_SETTINGS = gql`
  query GetNotificationSettings($userId: String!) {
    getNotificationSettings(userId: $userId) {
      id
      userId
      emailThresholds
      pushbulletThresholds
      webPushThresholds
      smsThresholds
      telegramThresholds
      eventTypeSettings
      maxNotificationsPerDay
      notificationCooldown
      digestEnabled
      digestFrequency
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateUserNotificationPreferences(
    $userId: String!
    $data: UpdateUserNotificationPreferencesInput!
  ) {
    updateUserNotificationPreferences(userId: $userId, data: $data)
  }
`;

export const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation UpdateNotificationSettings(
    $userId: String!
    $data: UpdateNotificationSettingsInput!
  ) {
    updateNotificationSettings(userId: $userId, data: $data) {
      id
      userId
      emailThresholds
      pushbulletThresholds
      webPushThresholds
      smsThresholds
      telegramThresholds
      eventTypeSettings
      maxNotificationsPerDay
      notificationCooldown
      digestEnabled
      digestFrequency
    }
  }
`;

export const CREATE_NOTIFICATION_SETTINGS = gql`
  mutation CreateNotificationSettings($data: CreateNotificationSettingsInput!) {
    createNotificationSettings(data: $data) {
      id
      userId
      emailThresholds
      pushbulletThresholds
      webPushThresholds
      smsThresholds
      telegramThresholds
      eventTypeSettings
      maxNotificationsPerDay
      notificationCooldown
      digestEnabled
      digestFrequency
    }
  }
`;

export const GET_NOTIFICATION_THRESHOLDS = gql`
  query GetNotificationThresholds($userId: String!, $channel: String!) {
    getNotificationThresholds(userId: $userId, channel: $channel)
  }
`;

export const SHOULD_SEND_NOTIFICATION = gql`
  query ShouldSendNotification(
    $userId: String!
    $eventType: String!
    $minutesUntilEvent: Int!
  ) {
    shouldSendNotification(
      userId: $userId
      eventType: $eventType
      minutesUntilEvent: $minutesUntilEvent
    )
  }
`;

// Legacy queries for backward compatibility
export const GET_NOTIFICATION_PREFERENCES = gql`
  query GetNotificationPreferences($userId: String!) {
    getUserNotificationPreferences(userId: $userId)
  }
`;

export const UPDATE_NOTIFICATION_PREFERENCES = gql`
  mutation UpdateNotificationPreferences(
    $userId: String!
    $preferences: UpdateUserNotificationPreferencesInput!
  ) {
    updateUserNotificationPreferences(userId: $userId, data: $preferences)
  }
`;

export const TEST_NOTIFICATION = gql`
  mutation TestNotification(
    $userId: String!
    $type: String!
    $title: String!
    $message: String!
  ) {
    testNotification(
      userId: $userId
      type: $type
      title: $title
      message: $message
    )
  }
`;

export const TEST_EMAIL_NOTIFICATION = gql`
  mutation TestEmailNotification($email: String!) {
    testEmailNotification(email: $email)
  }
`;

export const TEST_PUSHBULLET_NOTIFICATION = gql`
  mutation TestPushbulletNotification($pushbulletKey: String!) {
    testPushbulletNotification(pushbulletKey: $pushbulletKey)
  }
`;
